<template>
    <div>
      <!-- 001 Title 섹션 -->
      <b-card class="information">
        <div class="card-header">
          <!-- 타이틀 영역 -->
          <div class="title-wrap">
            <b-form-row class="align-items-center">
              <b-col class="mb-0 flex-column align-items-start">
                <span class="chat-id">{{ post.id }}</span>
                <b-input-group>
                  <b-form-input name="title" label="Title" id="title" placeholder="Title" size="xl" class="my-0"
                    style="height: 45px; font-size: 30px; border:none;" v-model="post.title" ref="title" v-validate="{required : true}"></b-form-input>
                  <b-form-invalid-feedback v-if="errors.has('title')" id="title-invalid-feedback">
                    Title is required.
                  </b-form-invalid-feedback>
                </b-input-group>
              </b-col>
            </b-form-row>
          </div>
        </div>
        <div class="card-body border-top" >
          <!-- / 001 Title 섹션 -->
          <!-- Spinner -->
          <loading :active.sync="loading"></loading>
          <!-- /Spinner -->
          <!-- Title -->
          <!-- /Title -->
          <!-- /Chatter Form ##########################################################################################################################################-->
        </div>
      </b-card>
      <b-card class="description">
        <!-- Description -->
        <b-form-group>
          <!-- <label for="description">Description<span class="required">*</span></label> -->
          <!-- @input이 b-form-textarea에서 정상적으로 적용이 안 돼서 editor에 추가함 -->
          <editor :init="editorOption" api-key="zwybj7ujqd6rsjj8fm19oc1u9ctrzmbv0ym5tqfsi29kbs7a" name="content" v-model="post.content"/>
          <b-form-invalid-feedback v-if="errors.has('content')" id="title-invalid-feedback">
            Title is required.
          </b-form-invalid-feedback>
          <b-form-textarea v-show="false" rows="12" id="content" name="content" v-model="post.content" v-validate="{required : true}" ref="content"></b-form-textarea>
        </b-form-group>
        <!-- /Description -->
      </b-card>
      <b-card class="file">
        <b-form-row class="align-items-end">
          <b-col class="mb-0">
            <!-- File -->
            <b-form-group label-for="file-input" class="new-file-label">
              <b-form-file multiple ref="file-input" id="file-input" name="file" v-model="fileInput.files"
                placeholder="Choose a file or drop it here" drop-placeholder="Drop a file here"
                class="chatter-new-file-input"></b-form-file>
            </b-form-group>
            <!-- /File -->
          </b-col>
        </b-form-row>
        <!-- File list -->
        <b-form-group v-if="showFiles()">
          <div class="file-list">
            <template v-for="file in post.files">
              <div v-if="!file.deleted" :key="file.fileName" class="d-flex justify-content-between file-item">
                <div class="file-info-area">
                  <span class="file-name">{{ file.fileName }}</span>
                  <span class="file-upload-time">{{ file.creationDate }}</span>
                  <div class="file-desc-area">
                    <b-input-group>
                      <b-form-input name="fileDesc" type="text" class="custom-input" style="font-size: 0.899rem"
                        placeholder="Type Description" maxlength="50s" v-model="file.description">
                      </b-form-input>
                    </b-input-group>
                  </div>
                </div>
                <div>
                  <div class="d-flex justify-content-between align-items-end">
                    <div>
                      <div class="chatter-file-size">
                        {{ formatFileSize(file.fileSize) }}
                      </div>
                      <b-badge v-if="!file.new" class="btn btn-file-download" variant="primary"
                        @click="downloadFile(file)">Download
                      </b-badge>
                    </div>
                    <div v-if="showImages()">
                      <div class="image-item" v-if="isImage(file)" :key="`${file.fileName}-${index}`">
                        <div @click="openImageInNewWindow(file.url)">
                          <img :src="file.url" class="image-box" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <b-badge variant="danger" class="btn btn-delete" @click="deleteFile(file)">Delete
                </b-badge>
              </div>
            </template>
          </div>
          <div class="chatter-file-size ready-to-upload">
            Ready to upload: {{ formatFileSize(readyToUploadFileSize) }}
            <span>* You can upload 100MB at a time.</span>
          </div>
          <div class="chatter-file-size total">
            Total: {{ formatFileSize(totalFileSize) }}
          </div>
        </b-form-group>
      </b-card>
      <!-- Reply -->
      <b-card v-if="!isNew" class="comment related" style="display:block">
      <!-- Header -->
        <div class="card-header d-flex justify-content-between">
          <h3>Comment</h3>
        </div>
        <div class="comment-area">
          <div class="comment-list-wrap">
            
            <div class="comment-list">
              <div v-for="comment in this.comments" :key="comment.id" class="comment-item">
                <comment ref="replyforms">
                </comment>
              </div>
            </div>
          </div>
          <!-- New Reply Form-->
          <comment :param="this.comment" ref="ChatterReply" class="comment-reply"></comment>
          <!-- /New Reply Form -->
        </div>
      <!-- /Header -->
      </b-card>
      <!-- /Reply -->

      <!-- Buttons -->
      <div v-if="!isNew" class="chatter-btn-wrap" :class="{ 'bottom': isPageEnd }">
        <!-- <div class="btn-move-wrap">
          <b-button @click="showPrevChatter" :disabled="!prevChatId" type="button" class="btn-line prev">Prev
          </b-button>
          <b-button @click="showNextChatter" :disabled="!nextChatId" type="button" class="btn-line next">Next
          </b-button>
        </div> -->
        <!-- <div class="text-container">
          <span class="d-flex text">
            Created by {{ post.creator.name }} ({{ post.creator.id }}) at {{ post.creationDate }}
          </span>
          <span class="d-flex text" v-if="post.updater.id" style="text-align : right;">
            Updated by {{ post.updater.id }} at {{ post.updatedDate }}
          </span>
        </div> -->
        <b-button @click="deletePost" variant="danger">
          Delete
        </b-button>

        <div v-if="!isNew" class="button-container">
          <div class="text-container" style="display:flex; justify-content: center; flex-direction: column;">
            <span class="d-flex text">
              Created by {{ post.creator.name }} ({{ post.creator.id }}) at {{ post.creationDate }}
            </span>
            <span class="d-flex text" v-if="post.updater.id" style="text-align : right;">
              Updated by {{ post.updater.name }} ({{ post.updater.id }}) at {{ post.updatedDate }}
            </span>
          </div>

          <b-button @click="cancel" type="button" class="btn-secondary">Close
          </b-button>
          <b-button @click="createReply(post.id)" type="button" class="btn-sub-primary">Reply
          </b-button>
          <b-button @click="updatePost" variant="outline-primary" class="btn-primary">Update
          </b-button>
        </div>
      </div>
      <div v-if="isNew" class="chatter-btn-wrap d-flex justify-content-end" :class="{ 'bottom': isPageEnd }">
        <b-button @click="cancel" type="button" class="btn-secondary">Cancel
        </b-button>
        <b-button @click="createPost" variant="primary" class="btn-primary">Write
        </b-button>
      </div>
      
    </div>
 </template>
  
  <script>
  import Loading from 'vue-loading-overlay';
  import { VueEditor } from 'vue2-editor';
  import Editor from '@tinymce/tinymce-vue';
  import Comment from "@/components/board/Comment.vue";
  
  export default {
    name: "PostDetail",
    props: {
      id: { type: String, requried: false, default: "" },        // update 시 파라미터로 받는 Chat ID
      parent: {type: String, required: false, default: ""}       // 부모글 아이디
    },
    components: { Loading, VueEditor, Editor, Comment},
    data() {
      return {
        clickUpdateBtn: false,
        loading: false,
        prevPost: {},
        post: {
          id: '',
          title: '',
          content: '',
          files: [],
          creator: {
            id: '',
            name: '',
            profileImage: '',
          },
          updater: {
            id: '',
            name: '',
            profileImage: '',
          },
          creationDate: '',
          updatedDate: '',
        },
        // totalFileSize: 0,
        comment: '',
        comments: [],
        fileInput: {
          files: [],
          type: '',
          description: '',
        },
        dateRule: { required: false, regex: /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/ },
        editorOption: {
          menubar: "file edit view insert format tools table help",
          plugins: [
            'advlist autolink lists link image charmap print preview anchor',
            'searchreplace visualblocks code fullscreen',
            'insertdatetime media table paste code help wordcount'
          ],
          toolbar:
            'undo redo | bold italic underline strikethrough | fontfamily fontsize blocks | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl',
          paste_data_images: true,
          image_advtab: true,
          statusbar: false,
          contextmenu: false,
        },
        // chatter-btn-wrap 페이지 끝 도달 시 클래스 부여 위해 추가함
        isPageEnd: false,
        // 스크롤 시 chatter-top-area의 title 노출 이벤트 위해 추가
        isScrollStart: false,
        // card 영역 접히고 펼치는 이벤트 위해 추가
        imageUrl : '',
        errorToastOptions: {
          title: `Notification`,
          toaster: "b-toaster-bottom-center",
          solid: true,
          appendToast: false,
          autoHideDelay: 500,
          variant: "danger"
        },
        toastOptions: {
          title: `Notification`,
          toaster: "b-toaster-bottom-center",
          solid: true,
          appendToast: false,
          autoHideDelay: 500
        },
      };
    },
    watch: {
      '$route.params.id': {
        handler(newRoute, oldRoute) {
          this.showOtherPostDetail(newRoute);
        },
        immediate: false // 컴포넌트가 생성될 때도 watch 핸들러를 호출할지 여부 설정
      },
      fileInput: {
        deep: true,
        handler() {
          if (!this.fileInput.files || this.fileInput.files.length === 0) return;
          this.fileInput.files.forEach(async file => {
            const clone = new File([file], file.name, { contentType: file.type, });
            let fileInfo = {
              id: '',
              fileName: file.name,
              path: '',
              type: this.fileInput.type,
              file: clone,
              new: true,
              deleted: false,
              url: '',
              fileSize: file.size,
            };
            fileInfo.url = this.isImage(fileInfo) ? await this.createFileURL(fileInfo) : null
            this.post.files.push(fileInfo);
          })
          this.$refs['file-input'].reset();
          this.fileInput.files = [];
        }
      },
    },
    computed: {
      isNew() {
        return this.id === '' || this.id === undefined || this.id === null;
      },
      totalFileSize() {
        let sum = 0;
        this.post.files.forEach(file => {
          if(!file.deleted) {
            sum += file.fileSize;  
          }
        })
  
        return sum;
      },
      readyToUploadFileSize() {
        let sum = 0;
        this.post.files.forEach(file => {
          // 파일이 삭제되지 않고 새로운 파일일 경우에 크기 합
          if(!file.deleted && file.new) {
            sum += file.fileSize;
          }
        })
  
        return sum;
      },

    },
    created() {
      // 파라미터로 받은 id가 있으면 게시글 조회
      if(this.id) {
        this.fetchData(this.id);
      }
    },
    mounted() {
      window.addEventListener('scroll', () => this.handleScroll());
      // 스크롤 시 chatter-top-area의 title 노출 이벤트 위해 추가
      window.addEventListener('scroll', () => this.showTitle());
    },
    // vue.js LifeCycle Hook Event 발생 시점 : 생성된 컴포넌트가 폐기 되는 시점
    beforeDestroy() {
      // chatter-btn-wrap 페이지 끝 도달 시 클래스 부여 위해 추가함
      window.removeEventListener('scroll', () => this.handleScroll());
      // 스크롤 시 chatter-top-area의 title 노출 이벤트 위해 추가
      window.removeEventListener('scroll', () => this.showTitle());
    },
    methods: {
      initData() {
        // Post 관련 데이터 초기화
        this.post = {
          id: '',
          title: '',
          content: '',
          files: [],
          creator: {
            id: '',
            name: '',
            profileImage: '',
          },
          updater: {
            id: '',
            name: '',
            profileImage: '',
          },
          creationDate: '',
          updatedDate: '',
        };
        this.prevPost = {};
        // totalFileSize: 0,
        this.reply = '';
      },
      async fetchData(id) {
        //TODO 게시글 상세조회 API 호출
        this.getPost(id);
        // this.getComments(id);
      },
      getPost(id) {
        try {
          this.loading = true;
          axios.get(`board/posts/${id}`,{
            headers: {
              Authorization: accessToken(),
              Accept: "application/json"
            }
          }).then(async (response) => {
            const status = response.data.status;
            if(status === "200") {
              // 파일 데이터
              const body = response.data.body;
              
              // TODO 파일 응답 시 주석 해제
              // body.post.files.map(file => {
              //   this.$set(file, 'deleted', false);
              //   this.$set(file, 'new', false);
              //   this.$set(file, 'url', this.isImage(file) ? this.createFileURL(file) : '');
              // });

              this.post = body;
              // 객체 깊은 복사
              this.prevPost = JSON.parse(JSON.stringify(this.post));
            } else {
              const message = response.data.message;
              await this.showMessage(message);
              this.pushRoute("/chatter/board");
            }
            // TODO 논리 에러 검증 로직 추가
          })
        } catch(e) {
          console.log(e);
          this.loading = false;
        } finally {
          this.loading = false;
        }
      },

      getComments() {
        // TODO 댓글 API 요청

      },
      isImage(file) {
        return !file.deleted && file.contentType && file.contentType.includes('image')
      },
      showFiles() {
        return this.post.files && this.post.files.length > 0 &&
          this.post.files.some(file => !file.deleted);
      },
      showImages() {
        return this.post.files && this.post.files.length > 0 &&
          this.post.files.some(file => this.isImage(file));
      },
  
      deleteFile(file) {
        file.deleted = true;
      },
      async createFileURL(file) {
        try {
          let data = null;
          if (file.new && file.file) {
            data = file.file;
          } else if (!file.new && file.attachedFilePath) {
            let response = await axios.get(`board/files/${file.id}/download`, {
              responseType: 'blob',
              headers: { Authorization: accessToken() }
            });
            data = response.data;
          }
          return data ? URL.createObjectURL(data) : null;
        } catch (error) {
          await this.showError(error);
        }
      },
      async createSubChatter() {
        this.pushRoute({ name: "chatCreate", params: { parentChatter: this.chat } });
        //dropdown 모두 닫기
        this.closeOptions();
  
      },
      toast(toaster, append = false) {
        this.counter++
        this.$bvToast.toast(`Toast ${this.counter} body content`, {
          title: ``,
          toaster: toaster,
          solid: true,
          appendToast: append
        })
      },
      async cancel() {
        this.pushRoute('/chatter/board');
      },
  
      async downloadFile(file) {
        if (file.fileSize < 0) {
          this.$bvToast.toast(`${file.attachedFilename} 파일을 찾을 수 없습니다.`, this.errorToastOptions);
          return;
        }
        try {
          this.loading = true;
          await this.download(file);
        } catch (error) {
          this.showError(error);
        } finally {
          this.loading = false;
        }
      },
      async download(file) {
        const link = document.createElement('a');
        let url = await this.createFileURL(file);
        if (url) {
          link.href = url;
          link.download = file.attachedFilename;
          link.click();
        }
      },
      async createPost() {
        const isValid = await this.validatePost();
        if(!isValid) {
          return;
        }

        const params = {
          title: this.post.title,
          content: this.post.content,
          parentId: this.parent
        }

        try {
          this.loading = true;
          // API 요청
          axios.post('board/posts', {}, {
            params: params,
            headers: {
              Authorization: accessToken(),
              ContentType: 'application/json'
            }
          }).then(response => {
            const data = response.data;
            if(data.status === "200") {
              const id = data.body;
              this.showOtherPostDetail(id);
              
            } else {
              this.$bvToast.toast(data.message, this.errorToastOptions);
            }
          });

        } catch(e) {
          console.log(e);
          this.loading = false;
        } finally {
          this.loading = false;
        }
      },
      async updatePost() {

        try {
          this.loading = true;

          // 이전 값과 비교했을 때 바뀐 것만 파라미터로 전송
          const params = {}

          // 제목 비교
          if(this.prevPost.title !== this.post.title) {
            params.title = this.post.title;
          }
          
          // 본문 비교
          if(this.prevPost.content !== this.post.content) {
            params.content = this.post.content;
          }

          // params가 비어있다면 (변경된게 없다면 리턴)
          if(Object.keys(params).length === 0) {
            this.loading = false;
            this.$bvToast.toast("변경된 내용이 없습니다.", this.errorToastOptions);
            return;
          }

          // TODO API 요청
          const response = await axios.post(`board/updatePost/${this.id}`, params, {
            headers: {
              Authorization: accessToken(),
              ContentType: 'application/json'
            }
          })

          const status = response.data.status;
          if(status === "200") {
            this.$bvToast.toast("업데이트를 완료하였습니다.", this.toastOptions);
          } else {
            this.$bvToast.toast(response.data.message, this.errorToastOptions);
          }
        } catch(e) {
          this.loading = false;
          console.log(e);

        } finally {
          this.loading = false;
        }
      },
      async validatePost() {

        return await this.$validator.validate().then(valid => {
          if (this.errors && this.errors.items.length > 0) {
            const errorItems = this.errors.items;
            const errorItemsLength = errorItems.length;
            for (let i = 0; i < errorItemsLength; i++) {
              const error = errorItems[i];
              this.$bvToast.toast(error.msg, this.errorToastOptions);
              if (this.$refs[error.field]) this.$refs[error.field].focus();
              break;
            }
            return false;
          }
          return true;
        });
      },
      createReply(parent) {
        this.initData();
        this.pushRoute({name: "postDetail", params: {parent: parent}});
      },
      showOtherPostDetail(id) {
        this.initData();
        if(id === undefined || id === '' || id === null) return;
        this.pushRoute('/chatter/post-detail/' + id);
        this.fetchData(id);
      },
      // chatter-btn-wrap 페이지 끝 도달 시 클래스 부여 위해 추가함
      handleScroll() {
        const scrollPosition = document.documentElement.scrollTop;
        if ((scrollPosition + window.innerHeight) >= document.body.scrollHeight) {
          this.isPageEnd = true;
        } else {
          this.isPageEnd = false;
        }
      },
      // 스크롤 시 chatter-top-area의 title 노출 이벤트 위해 추가
      showTitle() {
        const scrollPosition = document.documentElement.scrollTop;
        const chatterTopAreaPosY = document.querySelector('.chatter-top-area');
        if (chatterTopAreaPosY != null) {
          chatterTopAreaPosY.getBoundingClientRect().top;
        }
        if (scrollPosition >= chatterTopAreaPosY) {
          this.isScrollStart = true;
        } else {
          this.isScrollStart = false;
        }
      },
      toggleDropdown(target) {
        //Select Project 전에는 status dropdown 비활성화
        if(this.chat.projectId === '' && target === 'status'){
          return;
        }
        if(this.showDropdown === target) {
          this.showDropdown = '';
          return;
        }
        this.showDropdown = target;
      },
      openImageInNewWindow(imageUrl) {
        window.open(imageUrl, '_blank');
      },
      // 게시글 삭제
      async deletePost() {
        const confirmed = await this.showConfirm("해당 게시글을 삭제하시겠습니까?");

        if(!confirmed) {
          return;
        }

        try {
          this.loading = true;
          // 최초 작성자만 삭제 가능하도록 함
          if(this.currentUserId() !== this.post.creator.id) {
            this.$bvToast.toast("해당 게시글의 삭제권한이 없습니다.", this.errorToastOptions);
          }

          const response = await axios.delete(`board/posts/${this.id}`, {
            headers: {
              Authorization: accessToken(),
            }
          });

          const status = response.data.status;
          if (status === "200") {
            this.loading = false;
            await this.showMessage("게시글을 삭제하였습니다.");
            this.pushRoute("/chatter/board");
          } else {
            this.$bvToast.toast(response.data.message, this.errorToastOptions);
          }

        } catch(e) {
          console.log(e);
          this.loading = false;
        } finally {
          this.loading = false;
        }
      }
    },
    filters: {
      formatStatus(strStatus) {
        if (strStatus !== undefined) {
          let arrStrStatus = strStatus.split("_");
          let result = '';
          for (let i in arrStrStatus) {
            let str = arrStrStatus[i]
            result = result + " " + str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
          }
  
          return result
        }
      },
    },
  }
  </script>
  <style>
  .grid-container {
    display: grid;
  }
  
  .text-container {
    white-space: nowrap;
    /* 텍스트가 줄바꿈되지 않도록 설정 */
    overflow: hidden;
    /* 너비를 초과하는 텍스트를 감추기 */
    text-overflow: ellipsis;
    /* 초과된 텍스트를 "..."으로 표기 */
  }
  
  .button-container {
    white-space: nowrap;
    /* 텍스트가 줄바꿈되지 않도록 설정 */
    overflow: hidden;
    /* 너비를 초과하는 텍스트를 감추기 */
    margin: 0.2em;
    padding: 0.2em;
  }
  
  .card .card-body {
    margin-top: 0em;
    padding-top: 0%;
    padding-bottom: 1%;
  }
  
  .card .card-header {
    padding-left: 0;
    background-color: white !important;
  }
  
  span.required {
    color: red;
  }
  
  .image-title {
    display: block;
    margin-bottom: .3rem;
  }
  
  .image-box {
    display: block;
    max-width: 100%;
  }
  
  .hide-toolbar .ql-toolbar {
    display: none;
  }
  
  .hide-border .ql-container {
    border: none !important;
  }
  
  .custom-input {
    height: 2rem !important;
    line-height: 1.0 !important;
  }
  
  .custom-tags {
    height: 1.1rem !important;
  }
  
  .span-90 {
    width: 85%;
  }
  
  .badge-container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 20%;
  }
  
  .badge-container .btn {
    width: 50%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  
  }
  
  .custom-listTextstyle {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  
  .b-form-tags .badge {
    display: inline-flex !important;
    align-items: center !important;
    flex: 0 0 auto !important;
    line-height: 1 !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    height: 2em;
  }
  
  div[contenteditable="true"]:focus {
    outline: none;
  }
  
  .col-label {
    display: flex;
    justify-content: flex-end;
  }
  
  .tox-tinymce {
    border-radius: 0.6rem !important;
    min-height: 35rem !important;
  }
  
  .tox .tox-statusbar {
    display: none;
  }
  
  /* 신규 추가 스타일 */
  /* .btn-select-status .dropdown-toggle {
    display: flex;
    align-items: center;
    gap: 0 0.933rem;
    height: 100%;
    padding: 0.266rem 1.066rem 0.266rem 1.6rem;
    border: none;
    border-radius: 38px;
    color: #FFF;
    font-family: 'NanumGothic';
    font-size: 18px;
    font-weight: 500;
    line-height: 42px;
  }
  
  .btn-select-status.in-progress .dropdown-toggle,
  .btn-select-status.in-progress .dropdown-toggle.show,
  .btn-select-status.in-progress.show .dropdown-toggle,
  .btn-select-status.in-progress .dropdown-toggle:hover {
    background-color: #FF5C00;
  }
  
  .btn-select-status.to-do .dropdown-toggle,
  .btn-select-status.to-do .dropdown-toggle.show,
  .btn-select-status.to-do.show .dropdown-toggle,
  .btn-select-status.to-do .dropdown-toggle:hover {
    background-color: #747480;
  }
  
  .btn-select-status.done .dropdown-toggle,
  .btn-select-status.done .dropdown-toggle.show,
  .btn-select-status.done.show .dropdown-toggle,
  .btn-select-status.done .dropdown-toggle:hover {
    background-color: #1755CC;
  }
  
  .btn-select-status.closed .dropdown-toggle,
  .btn-select-status.closed .dropdown-toggle.show,
  .btn-select-status.closed.show .dropdown-toggle,
  .btn-select-status.closed .dropdown-toggle:hover {
    background-color: #168D4C;
  }
  
  .btn-select-status.cancelled .dropdown-toggle,
  .btn-select-status.cancelled .dropdown-toggle.show,
  .btn-select-status.cancelled.show .dropdown-toggle,
  .btn-select-status.cancelled .dropdown-toggle:hover {
    background-color: #E4E4EA;
    color: #747480;
  }
  
  .btn-select-status .dropdown-toggle::after {
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-left: 0;
    content: "";
    border: none;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.832 7.5L9.9987 13.3333L4.16536 7.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat;
  } */
  
  .card.description .tox-tinymce {
    border: none !important;
  }
  
  .b-form-tag>button.b-form-tag-remove {
    width: 16px;
    height: 16px;
    font-size: 0 !important;
    opacity: 1;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M12 12L4 4" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 4L4 12" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat;
  }
  
  .card.file .card-body {
    padding: 2.666rem 2.0833vw;
  }
  
  .new-file-label label {
    padding-left: 0.4rem;
    margin-bottom: 0.53rem;
    color: #2E2E38;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 700;
    line-height: 150%;
  }
  
  .chatter-new-file-input .custom-file-input {
    height: 100%;
  }
  
  .chatter-new-file-input .custom-file-input~.custom-file-label[data-browse]::after {
    content: none;
  }
  
  .chatter-new-file-input .custom-file-input.focus {
    border: none;
    box-shadow: none;
  }
  
  .chatter-new-file-input label.custom-file-label {
    display: flex;
    justify-content: center;
    height: 100%;
    padding: 1.533rem 0;
    margin-bottom: 0;
    border-radius: 10px;
    border: 1px solid #E7E7EE;
    background-color: #FFF;
  }
  
  .chatter-new-file-input label.custom-file-label:hover {
    border-color: #2E2E38;
    cursor: pointer;
  }
  
  .chatter-new-file-input .custom-file-label span {
    padding-left: 30px;
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M18 21H6C5.44772 21 5 20.5523 5 20L5 4C5 3.44772 5.44772 3 6 3L13.5631 3C13.8416 3 14.1076 3.11619 14.2968 3.32059L18.7338 8.11246C18.9049 8.29731 19 8.53995 19 8.79187L19 20C19 20.5523 18.5523 21 18 21Z" stroke="%23747480" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M19 9L14 9C13.4477 9 13 8.55228 13 8L13 3" stroke="%23747480" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
    background-repeat: no-repeat;
    background-position: 0 center;
    color: #747480;
    font-family: 'NanumGothic';
    font-size: 16px;
    font-weight: 400;
    line-height: 150%;
  }
  
  .chatter-new-file-input .custom-file-label:hover span {
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M18 21H6C5.44772 21 5 20.5523 5 20L5 4C5 3.44772 5.44772 3 6 3L13.5631 3C13.8416 3 14.1076 3.11619 14.2968 3.32059L18.7338 8.11246C18.9049 8.29731 19 8.53995 19 8.79187L19 20C19 20.5523 18.5523 21 18 21Z" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M19 9L14 9C13.4477 9 13 8.55228 13 8L13 3" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
    color: #2E2E38;
  }
  
  .chatter-new-file-input .custom-file-input:focus~.custom-file-label {
    border-color: #2E2E38;
    box-shadow: none;
  }
  
  /* comment 영역 */
  .card.comment {
    position: relative;
  }
  
  .card.comment .card {
    margin-bottom: 0;
    border-radius: 0 0 0 30px;
    box-shadow: none;
  }
  
  .card.comment .card-body {
    padding: 0;
  }
  
  .card.comment .card-body .form-group {
    margin: 0;
  }
  
  .card.comment .card.comment-reply .ql-toolbar.ql-snow {
    border-top: 1px solid #DDDDE3;
    border-bottom: 1px solid #DDDDE3;
    border-left: none;
    border-right: none;
  }
  
  .card.comment .card.comment-reply .ql-container.ql-snow {
    border: none;
  }
  
  /* add watcher 팝업 */
  .modal-open #watchersTable.modal {
    overflow-y: hidden;
  }
  
  #watchersTable.modal.show .modal-dialog {
    margin: 0 auto;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  
  #watchersTable .modal-content {
    border-radius: 20px;
  }
  
  #watchersTable .modal-header {
    align-items: center;
    padding: 2.083vw 2.666rem 1.041vw;
    border-radius: 20px 20px 0 0;
    border-bottom: 0px;
  }
  
  #watchersTable .modal-header h5 {
    margin-bottom: 0 !important;
    color: #2E2E38;
    font-family: 'NanumGothic';
    font-size: 24px;
    font-weight: 700;
    line-height: 150%;
  }
  
  #watchersTable .modal-body {
    padding: 1.041vw 1.6rem 1.041vw 2.666rem;
  }
  
  #watchersTable .modal-footer {
    justify-content: center;
    gap: 0 0.666rem;
    padding: 1.362vh 2.666rem 2.604vw;
    border-top: 0px;
    border-radius: 0 0 20px 20px;
  }
  
  #watchersTable .btn {
    margin: 0;
    border-radius: 10px;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 500;
    line-height: 150%;
  }
  
  #watchersTable .btn-primary {
    width: 148px;
    height: 40px;
    background-color: #2E2E38;
    color: #FFE600;
    border-color: transparent;
  }
  
  #watchersTable .btn-primary:hover {
    color: #FFE600;
    background-color: #0D0D17;
    border-color: transparent;
  }
  
  #watchersTable .btn-primary.disabled,
  #watchersTable .btn-primary:disabled {
    color: #9C9CA8;
    background-color: #C4C4CD;
    border-color: transparent;
  }
  
  #watchersTable .modal-footer .btn-secondary {
    width: 148px;
    height: 40px;
    margin: 0;
    border-radius: 10px;
    background: #747480;
    color: #fff;
    border-radius: 10px;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 500;
    line-height: 150%;
  }
  
  #watchersTable .modal-footer .btn-secondary:hover {
    background-color: #565662;
  }
  
  #watchersTable .modal-footer .btn-secondary.disabled,
  #watchersTable .modal-footer .btn-secondary:disabled {
    color: #9C9CA8;
    background-color: #C4C4CD;
    border-color: transparent;
  }
  
  /* related chatter, subordinate chatter 팝업 */
  #relatedToTable.modal.show .modal-dialog,
  #subordinateToTable.modal.show .modal-dialog {
    margin: 0 auto;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  
  #relatedToTable .modal-content,
  #subordinateToTable .modal-content {
    border-radius: 20px;
  }
  
  #relatedToTable .modal-header,
  #subordinateToTable .modal-header {
    align-items: center;
    padding: 2.083vw 2.666rem 1.041vw;
    border-radius: 20px 20px 0 0;
    border-bottom: 0px;
  }
  
  #relatedToTable .modal-header h5,
  #subordinateToTable .modal-header h5 {
    margin-bottom: 0 !important;
    color: #2E2E38;
    font-family: 'NanumGothic';
    font-size: 24px;
    font-weight: 700;
    line-height: 150%;
  }
  
  #relatedToTable .modal-body,
  #subordinateToTable .modal-body {
    padding: 1.041vw 1.6rem 1.041vw 2.666rem;
  }
  
  #relatedToTable .modal-footer,
  #subordinateToTable .modal-footer {
    justify-content: center;
    gap: 0 0.666rem;
    padding: 1.362vh 2.666rem 2.604vw;
    border-top: 0px;
    border-radius: 0 0 20px 20px;
  }
  
  #relatedToTable .btn,
  #subordinateToTable .btn {
    margin: 0;
    border-radius: 10px;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 500;
    line-height: 150%;
  }
  
  #relatedToTable .btn-primary,
  #subordinateToTable .btn-primary {
    width: 148px;
    height: 40px;
    background-color: #2E2E38;
    color: #FFE600;
    border-color: transparent;
  }
  
  #relatedToTable .btn-primary:hover,
  #subordinateToTable .btn-primary:hover {
    color: #FFE600;
    background-color: #0D0D17;
    border-color: transparent;
  }
  
  #relatedToTable .btn-primary.disabled,
  #relatedToTable .btn-primary:disabled,
  #subordinateToTable .btn-primary.disabled,
  #subordinateToTable .btn-primary:disabled {
    color: #9C9CA8;
    background-color: #C4C4CD;
    border-color: transparent;
  }
  
  #relatedToTable .modal-footer .btn-secondary,
  #subordinateToTable .modal-footer .btn-secondary {
    width: 148px;
    height: 40px;
    margin: 0;
    border-radius: 10px;
    background: #747480;
    color: #fff;
    border-radius: 10px;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 500;
    line-height: 150%;
  }
  
  #relatedToTable .modal-footer .btn-secondary:hover,
  #subordinateToTable .modal-footer .btn-secondary:hover {
    background-color: #565662;
  }
  
  #relatedToTable .modal-footer .btn-secondary.disabled,
  #relatedToTable .modal-footer .btn-secondary:disabled,
  #subordinateToTable .modal-footer .btn-secondary.disabled,
  #subordinateToTable .modal-footer .btn-secondary:disabled {
    color: #9C9CA8;
    background-color: #C4C4CD;
    border-color: transparent;
  }

  </style>
  <style scoped>
  /* import font */
  @import url('https://hangeul.pstatic.net/hangeul_static/css/nanum-gothic.css');
  
  /* button */
  .btn {
    border-radius: 10px;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 500;
    line-height: 150%;
  }
  
  .btn:focus {
    box-shadow: none;
  }
  
  .btn-primary {
    width: 280px;
    height: 60px;
    background-color: #2E2E38;
    color: #FFE600;
    border-color: transparent;
  }
  
  /* .btn-primary:hover, */
  .btn-primary:active,
  .btn-primary:focus {
    color: #FFE600 !important;
    background-color: #0D0D17 !important;
    border-color: transparent !important;
    box-shadow: unset;
  }
  
  .btn-primary.disabled,
  .btn-primary:disabled {
    color: #9C9CA8;
    background-color: #C4C4CD;
    border-color: transparent;
  }
  
  .btn-secondary {
    width: 148px;
    height: 60px;
    border-radius: 10px;
    background: #747480;
    color: #fff;
  }
  
  .btn-secondary.small {
    height: 40px;
  }
  
  .btn-secondary:hover {
    background-color: #565662;
  }
  
  .btn-secondary.disabled,
  .btn-secondary:disabled {
    color: #9C9CA8;
    background-color: #C4C4CD;
    border-color: transparent;
  }
  
  .btn-sub-primary {
    width: 140px;
    height: 60px;
    background-color: #2E2E38;
    border: none;
    color: #FFF;
  }
  
  .btn-sub-primary:hover {
    background-color: #0D0D17;
  }
  
  .btn-sub-primary.disabled,
  .btn-sub-primary:disabled {
    color: #9C9CA8;
    background-color: #C4C4CD;
    border-color: transparent;
  }
  
  .btn-line {
    position: relative;
    width: 100px;
    height: 60px;
    border: 1px solid #C4C4CD;
    background-color: transparent;
    color: #2E2E38;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 500;
    line-height: 150%;
    text-align: inherit;
  }
  
  .btn-line:hover {
    color: #2E2E38;
    border: 1px solid #2E2E38;
    background-color: transparent;
  }
  
  .btn-line.disabled,
  .btn-line:disabled {
    border: 1px solid #DDDDE3;
    background-color: transparent;
  }
  
  .btn-line.small {
    height: 40px;
  }
  
  .btn-line.prev {
    padding: 0 1.866rem 0 2.866rem;
  }
  
  .btn-line.prev::before {
    content: '';
    display: block;
    position: absolute;
    left: 1.133rem;
    top: 1.466rem;
    width: 16px;
    height: 16px;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10.5 2L4.5 8L10.5 14" stroke="%232E2E38" stroke-linecap="round"/></svg>') center no-repeat;
  }
  
  .btn-line.prev.disabled::before,
  .btn-line.prev:disabled::before {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10.5 2L4.5 8L10.5 14" stroke="%23DDDDE3" stroke-linecap="round"/></svg>') center no-repeat;
  }
  
  .btn-line.next {
    padding: 0 2.866rem 0 1.866rem;
  }
  
  .btn-line.next::before {
    content: '';
    display: block;
    position: absolute;
    right: 1.133rem;
    top: 1.466rem;
    width: 16px;
    height: 16px;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none"><path d="M6 14L12 8L6 2" stroke="%232E2E38" stroke-linecap="round"/></svg>') center no-repeat;
  }
  
  .btn-line.next.disabled::before,
  .btn-line.next:disabled::before {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none"><path d="M6 14L12 8L6 2" stroke="%23DDDDE3" stroke-linecap="round"/></svg>') center no-repeat;
  }
  
  .btn-delete,
  .badge-container .btn-delete {
    width: 16px !important;
    height: 16px;
    font-size: 0 !important;
    background: transparent url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M12 12L4 4" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 4L4 12" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>') center/16px 16px no-repeat;
  }
  
  .btn-card-fold {
    position: absolute;
    top: 2rem;
    right: 2.666rem;
    display: block;
    width: 30px;
    height: 30px;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path d="M23.75 18.75L15 10L6.25 18.75" stroke="%232E2E38" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat;
    border: none;
    z-index: 100;
  }
  
  .btn-card-fold.fold {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path d="M23.75 11.25L15 20L6.25 11.25" stroke="%232E2E38" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat;
  }
  
  .btn-file-download {
    padding: 0.4rem 0.8rem;
    height: 30px;
    border-radius: 6px;
    border: 1px solid #C4C4CD;
    background-color: #FFF;
    color: #2E2E38;
    font-family: 'NanumGothic';
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
  }
  
  .btn-file-download:hover {
    border: 1px solid #747480;
  }
  
  /* 공통요소 */
  span.required {
    display: inline-block;
    width: 4px;
    height: 4px;
    background-color: #FF0000;
    border-radius: 50%;
    font-size: 0;
  }
  
  .border-bottom {
    border-bottom: 1px solid #DDDDE3;
  }
  
  .border-top {
    border-top: 1px solid #DDDDE3;
  }
  
  .mb-0 {
    margin-bottom: 0 !important;
  }
  
  .flex-grow {
    flex-grow: 1;
  }
  
  .custom-scrollbar::-webkit-scrollbar {
    width: 20px;
    border-bottom: 30px solid transparent;
    border-right: 14px solid transparent;
    background-clip: padding-box;
  }
  
  .custom-scrollbar::-webkit-scrollbar-track {
    width: 6px;
    background-color: #F6F6FA;
    border-bottom: 30px solid transparent;
    border-right: 14px solid transparent;
    background-clip: padding-box;
  }
  
  .custom-scrollbar::-webkit-scrollbar-thumb {
    width: 100%;
    background-color: #C4C4CD;
    border-bottom: 30px solid transparent;
    border-right: 14px solid transparent;
    background-clip: padding-box;
  }
  
  .select-custom-scrollbar::-webkit-scrollbar {
    width: 12px;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 6px solid transparent;
    background-clip: padding-box;
  }
  
  .select-custom-scrollbar::-webkit-scrollbar-track {
    width: 6px;
    background-color: #E7E7EE;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 6px solid transparent;
    background-clip: padding-box;
  }
  
  .select-custom-scrollbar::-webkit-scrollbar-thumb {
    width: 100%;
    background-color: #C4C4CD;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 6px solid transparent;
    background-clip: padding-box;
  }
  
  /* select */
  .custom-select {
    padding: 0.533rem 2.266rem 0.533rem 1.066rem;
    height: 2.666rem;
    border-radius: 10px;
    border: 1px solid #E7E7EE;
    background-color: #FFF;
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
    background-position: calc(100% - 12px) 9px;
    background-size: 20px 20px;
    background-repeat: no-repeat;
    font-family: 'NanumGothic';
    color: #2E2E38;
    font-size: 16px;
    font-weight: 400;
    line-height: 150%;
    width: 9vw;
  }
  
  .custom-select:focus {
    border-color: #E7E7EE;
    box-shadow: unset;
  }
  
  .custom-select.is-valid {
    border: 1px solid #00A438;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>') right 10px center/20px 20px no-repeat,
      url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M2.5 8L6.01924 11.8392C6.0985 11.9256 6.23483 11.9256 6.3141 11.8392L13.5 4" stroke="%2300A438" stroke-width="2" stroke-linecap="round"/></svg>') center right 2.4rem/16px 16px no-repeat;
  }
  
  .custom-select.is-invalid {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>') right 10px center/20px 20px no-repeat,
      url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><rect width="16" height="16" rx="8" fill="%23FF0000"/><rect x="7" y="3" width="2" height="7" rx="1" fill="white"/><rect x="7" y="11" width="2" height="2" rx="1" fill="white"/></svg>') center right 2.4rem/16px 16px no-repeat;
  }
  
  .custom-select.is-valid:focus {
    box-shadow: none;
    border: 1px solid #00A438;
  }
  
  .custom-select.is-invalid:focus {
    box-shadow: none;
    border: 1px solid #FF0000;
  }
  
  .custom-select:disabled {
    border: 1px solid #E7E7EE !important;
    background-color: #E0E0E7 !important;
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none"><path d="M16.5 7.5L10.6667 13.3333L4.83333 7.5" stroke="%23747480" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  }
  
  .custom-select#project-list {
    padding: 0.266rem 0.8rem 0.266rem 1.2rem;
    border-radius: 38px;
    background-color: #E4E4EA;
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
    background-position: calc(100% - 12px) 7px;
    background-size: 20px 20px;
    background-repeat: no-repeat;
    font-size: 18px;
    font-weight: 500;
    line-height: 150%;
  }
  
  /* custom select */
  .custom-select-area {
    padding-right: 0.78125vw;
    padding-left: 0.7812vw;
  }
  
  .custom-select-box {
    position: relative;
    width: fit-content;
    max-width: 220px;
    min-width: 180px;
    text-align: left;
    cursor: default;
    font-family: 'NanumGothic';
  }
  
  .custom-select-box .select {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0 0.666rem;
    width: 100%;
    height: 50px;
    padding-left: 1.2rem;
    padding-right: 0.8rem;
    border-radius: 38px;
    border: 1px solid transparent;
    background-color: #FFE500;
  }
  
  .custom-select-box-status {
    position: relative;
    max-width: 220px;
    min-width: 90px;
    cursor: default;
    font-family: 'NanumGothic';
    display: flex;
    height: 100%;
    border: none;
    color: #FFF;
    font-size: 18px;
    font-weight: 500;
    line-height: 42px;
  }
  
  .custom-select-box-status .select {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0 0.666rem;
    width: 100%;
    height: 50px;
    padding-left: 1.2rem;
    padding-right: 0.8rem;
    border-radius: 38px;
    border: 1px solid transparent;
  }
  
  .custom-select-box-status .select.to-do {
    background-color: #747480;
  }
  
  .custom-select-box-status .select.in-progress {
    background-color: #FF5C00;
  }
  
  .custom-select-box-status .select.done {
    background-color: #1755CC;
  }
  
  .custom-select-box-status .select.closed {
    background-color: #168D4C;
  }
  
  .custom-select-box-status .select.cancelled {
    background-color: #E4E4EA;
    color: #747480;
  }
  
  .custom-select-box-status .opt-list {
    display: none;
    position: absolute;
    top: 3.666rem;
    left: 0;
    z-index: 150;
    width: 100%;
    max-height: 230px;
    padding: 0.4rem;
    border-radius: 10px;
    border: 1px solid #E7E7EE;
    background-color: #F6F6FA;
    box-shadow: 0px 20px 20px 0px rgba(0, 0, 0, 0.14);
    list-style: none;
    overflow-y: auto;
  }
  
  .custom-select-box-status .opt-list .opt-inner {
    padding: 0rem 0.4rem;
    border-radius: 6px;
    background-color: #F6F6FA;
    color: #747480;
    font-size: 12px;
    font-weight: 500;
  }
  
  .custom-select-box-status.active .opt-list {
    display: block;
  }
  
  .custom-select-box-status .opt-item:hover .opt-inner {
    background-color: #E7E7EE;
    color: #2E2E38;
    font-weight: 700;
  }
  
  .custom-select-box-status .select .icon-arrow {
    flex-shrink: 0;
    display: block;
    width: 20px;
    height: 20px;
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none" ><path d="M15.8335 8L10.0002 13.8333L4.16683 8" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
    background-repeat: no-repeat;
  }
  
  .custom-select-box-status.active .select .icon-arrow {
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none"><path d="M15.8334 13L10 7.16667L4.16671 13" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  }
  
  
  .custom-select-box .select .select-title {
    position: relative;
    width: calc(100% - 2rem);
  }
  
  .custom-select-box .select .text {
    position: relative;
    display: block;
    width: 100%;
    font-size: 18px;
    font-weight: 500;
    color: #2E2E38;
    line-height: 1.8;
    appearance: none;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  
  .custom-select-box .select .icon-arrow {
    flex-shrink: 0;
    display: block;
    width: 20px;
    height: 20px;
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none"><path d="M15.8335 8L10.0002 13.8333L4.16683 8" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
    background-repeat: no-repeat;
  }
  
  .custom-select-box .select .required {
    content: '';
    display: block;
    position: absolute;
    top: 8px;
    right: -6px;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: #FF0000;
  }
  
  .custom-select-box.active .select {
    background-color: #fff;
    border-color: #000;
  }
  
  .custom-select-box.active .select .text {
    color: #2E2E38;
  }
  
  .custom-select-box.active .select .text::after {
    content: none;
  }
  
  .custom-select-box.active .select .icon-arrow {
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none"><path d="M15.8334 13L10 7.16667L4.16671 13" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  }
  
  .custom-select-box .opt-list {
    display: none;
    position: absolute;
    top: 3.666rem;
    left: 0;
    z-index: 150;
    width: 100%;
    max-height: 200px;
    padding: 0.4rem;
    border-radius: 10px;
    border: 1px solid #E7E7EE;
    background-color: #F6F6FA;
    box-shadow: 0px 20px 20px 0px rgba(0, 0, 0, 0.14);
    list-style: none;
    overflow-y: auto;
  }
  
  .custom-select-box .opt-list .opt-inner {
    padding: 0.4rem 0.8rem;
    border-radius: 6px;
    background-color: #F6F6FA;
    color: #747480;
    font-size: 12px;
    font-weight: 500;
  }
  
  .custom-select-box.active .opt-list {
    display: block;
  }
  
  .custom-select-box .opt-item:hover .opt-inner {
    background-color: #E7E7EE;
    color: #2E2E38;
    font-weight: 700;
  }
  
  /* input */
  .form-group {
    margin-bottom: 0;
  }
  
  .title-wrap .form-group {
    margin-bottom: 0;
  }
  
  label {
    padding-left: 0.4rem;
    margin-bottom: 0.53rem;
    color: #2E2E38;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 700;
    line-height: 150%;
  }
  
  .custom-input,
  input[type="date"].form-control input[type="time"].form-control,
  input[type="datetime-local"].form-control,
  input[type="month"].form-control {
    padding: 0.533rem 0.8rem 0.533rem 1.066rem;
    height: 2.666rem !important;
    border-radius: 10px;
    border: 1px solid #E7E7EE;
    background-color: #FFF;
    font-family: 'NanumGothic';
    color: #2E2E38;
    font-size: 16px;
    font-weight: 400;
    line-height: 150% !important;
  }
  
  .custom-input.small {
    width: min(15.866rem, 12.395vw);
  }
  
  .form-control#title {
    padding-left: 1px;
    background-color: transparent;
    font-family: 'NanumGothic';
    font-weight: 700;
  }
  
  .form-control#title::placeholder {
    font-size: 30px;
  }
  
  .form-control:focus {
    box-shadow: none;
    border-color: unset;
  }
  
  .form-control.is-valid {
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M2.5 8L6.01924 11.8392C6.0985 11.9256 6.23483 11.9256 6.3141 11.8392L13.5 4" stroke="%2300A438" stroke-width="2" stroke-linecap="round"/></svg>');
  }
  
  .form-control.is-invalid {
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><rect width="16" height="16" rx="8" fill="%23FF0000"/><rect x="7" y="3" width="2" height="7" rx="1" fill="white"/><rect x="7" y="11" width="2" height="2" rx="1" fill="white"/></svg>');
  }
  
  .form-control.is-valid:focus {
    box-shadow: 0 0 0 1px #00A438;
  }
  
  .form-control.is-invalid:focus {
    box-shadow: 0 0 0 1px #FF0000;
  }
  
  .input-group:not(.has-validation)>.form-control:not(:last-child) {
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    padding: 0.533rem 0.8rem 0.533rem 1.066rem;
    height: 2.666rem !important;
    border-radius: 10px;
    border: 1px solid #E7E7EE;
    background-color: #FFF;
    font-family: 'NanumGothic';
    color: #2E2E38;
    font-size: 16px;
    font-weight: 400;
    line-height: 150% !important;
  }
  
  .custom-file {
    height: 4.666rem;
  }
  
  /* form */
  .form-wrap {
    padding: 2.0833vw 0 0.5208vw;
  }
  
  .form-wrap:last-child {
    padding: 2.0833vw 0 0;
  }
  
  .form-row {
    margin-left: -0.7812vw;
    margin-right: -0.7812vw;
  }
  
  .form-row>.col,
  .form-row>[class*="col-"] {
    padding-right: 0.78125vw;
    padding-left: 0.7812vw;
    margin-bottom: 1.5625vw;
  }
  
  .invalid-feedback {
    position: absolute;
    margin-top: 2px;
    padding-left: 6px;
    color: #FF0000;
    font-family: 'NanumGothic';
    font-size: 12px;
    font-weight: 400;
    line-height: 150%;
  }
  
  /* card 영역 */
  .card {
    margin-bottom: 2rem;
    border-radius: 30px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
  }
  
  .card .card-header {
    border-radius: 30px;
    padding: 2rem;
    border-bottom: none;
  }
  
  .card>.card-body {
    padding-top: max(2rem, 1.5625vw);
    padding-left: 2.0833vw;
    padding-right: 2.0833vw;
    padding-bottom: max(2.666rem, 2.0833vw);
  }
  
  .card .card-body .card-body {
    padding: 0;
  }
  
  .card .card-body.fold {
    height: 0;
    min-height: 0 !important;
    padding: 0 !important;
    overflow: hidden;
    border-top: none !important;
  }
  
  .card.description .card-body {
    padding: 0.666rem 0.666rem 1.666rem;
  }
  
  .card .title-wrap {
    margin-top: -0.666rem;
  }
  
  
  .card.information {
    overflow: hidden;
  }
  
  .card.information>.card-body {
    padding: 0;
  }
  
  .card.information>.card-body>.card-header {
    padding: max(2rem, 1.5625vw) 2.0833vw 0;
  }
  
  .card.information>.card-body>.card-header .title-wrap {
    margin-top: 0;
    margin-bottom: 1.333rem;
  }
  
  .card.information .info-set-area .row {
    margin: 0;
    padding: 0;
  }
  
  .card.information .info-set-area .col {
    padding: 2.0833vw 1.125vw 1vw 2.0833vw;
  }
  
  .grid-container {
    grid-template-columns: auto 1fr;
    gap: 1.5625vw 12px;
    margin-top: 1.5625vw;
  }
  
  .card.information .grid-container label {
    grid-column: 1 / 2;
    width: max-content;
    padding-left: 0.5208vw;
  }
  
  .card.information .grid-container .option-list {
    grid-column: 2 / 3;
    gap: 0 10px;
    width: 100%;
    margin: 0;
    padding: 0;
    list-style: none;
  }
  
  .card.information .grid-container .option-item {
    flex: 1;
  }
  
  .card.information .grid-container .option-item input[type="radio"] {
    display: none;
    width: 0;
    height: 0;
    overflow: hidden;
    visibility: hidden;
  }
  
  .card.information .grid-container .option-item .option {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 40px;
    border-radius: 40px;
    background: #F6F6FA;
    color: #747480;
    text-align: center;
    font-family: NanumGothic;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
    cursor: pointer;
  }
  
  .card.information .grid-container .option-item .option:hover {
    background: #E7E7EE;
  }
  
  .card.information .grid-container .option-item input[type="radio"]:checked+.option {
    background: #2E2E38;
    color: #FFE500;
  }
  
  .card.information .info-set-area .col .info-set-row {
    margin: 0 -0.78125vw;
    padding: 0 0.5208vw;
  }
  
  .select-max-w {
    max-width: calc(100% - 80px) !important;
  }
  
  .card.information .info-set-area .col.col-lv {
    flex: 0 0 clamp(250px, 17.5vw, 336px);
    justify-content: space-between;
    gap: 1.5625vw;
    margin: 0;
    padding: 2.34375vw 2.0833vw;
    border-left: 1px solid #DDDDE3;
  }
  
  .card.information .info-set-area .col.col-lv .form-row {
    flex-wrap: nowrap;
  }
  
  .card.information .info-set-area .col.col-lv label {
    width: 30px;
    min-width: 30px;
    margin-right: 12px;
    margin-bottom: 0;
  }
  
  .card.information .info-set-area .col.col-lv .form-group {
    min-width: calc(100% - 60px);
    max-width: calc(100% - 60px);
  }
  
  .card.information .form-row {
    margin-left: 0;
    margin-right: 0;
  }
  
  .card.information .form-row>[class*="col-"] {
    padding-left: 0.78125vw;
    padding-right: 0.78125vw;
  }
  
  .card.information .info-set-area .form-wrap.bottom {
    padding: 1.5625vw 1.3625vw 1.5625vw 2.0833vw;
    background: #E7E7EE;
  }
  
  .card.information .info-set-area .form-wrap.middle {
    padding: 1vw 2.0833vw 1vw 2.6833vw;
    background: #E7E7EE;
    border-bottom: 1px solid #d1d1d1;
  }
  
  .card.information .info-set-area .form-wrap.bottom .col {
    display: flex;
    align-items: flex-end;
    margin: 0;
    padding: 0;
  }
  
  .card.information .info-set-area .form-wrap.bottom input {
    width: clamp(100px, 8.5417vw, 164px);
  }
  
  .card.information .info-set-area .form-wrap.bottom input[type="date"] {
    width: 168px;
  }
  
  .card.information .info-set-area .form-wrap.bottom input[type="text"] {
    width: 140px;
  }
  
  
  /* 상단 상태 + add a subordinate to chatter 영역 */
  .chatter-top-area {
    position: relative;
    display: flex;
    align-items: center;
    gap: 0 0.666rem;
    z-index: 100;
    transition: left ease-in-out 0.3s;
  }
  
  .chatter-top-area.fixed {
    position: fixed;
    top: 81px;
    left: 16.666%;
    width: 83.334%;
    padding: 0 3.125vw;
  }
  
  .full .chatter-top-area.fixed {
    top: 81px;
    left: 0;
    width: 100%;
  }
  
  .chatter-top-area .chatter-sub-area {
    display: flex;
    align-items: center;
    gap: 0 0.666rem;
  }
  
  .chatter-top-area .form-row {
    margin-left: 0;
  }
  
  .chatter-top-area .title-area {
    padding: 0.766rem 1.6rem;
    color: #FFF;
    font-family: 'NanumGothic';
    font-size: 18px;
    font-weight: 500;
    line-height: 150%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    border-radius: 60px;
    background-color: #2E2E38;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
  }
  
  .chat-id {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    color: #2E2E38;
    font-family: 'NanumGothic';
    font-size: 18px;
    font-weight: 500;
    line-height: 150%;
    white-space: nowrap;
    transform: translateY(-5px);
  }
  
  /* 날짜 영역 / work hour 영역 */
  .date-wrap {
    display: flex;
    align-items: center;
    gap: 0 0.666rem;
  }
  
  .date-wrap .mb-0 {
    padding-left: 0.7812vw;
  }
  
  .date-wrap .mb-0:first-child {
    padding-right: 0.7812vw;
  }
  
  .date-wrap .tilde {
    color: #747480;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 500;
    line-height: 150%;
  }
  
  /* add watcher + related chatter 영역 */
  .add-wrap {
    display: flex;
    gap: 0 2rem;
  }
  
  .add-wrap .card>.card-body {
    padding: 0;
  }
  
  .add-wrap .card .card-body .card-header {
    padding: 2rem 2.0833vw;
    border-radius: 30px 30px 0 0;
  }
  
  .add-wrap .card .card-body .card-body {
    padding: 0 2.0833vw;
    margin-bottom: 0.4rem;
    max-height: 15.333rem;
    min-height: 15.333rem;
    overflow-y: auto;
  }
  
  .add-wrap .card.related .card-body .card-body {
    padding: 0;
    margin-bottom: 0;
    max-height: unset;
    min-height: unset;
    overflow-y: unset;
  }
  
  .add-wrap .card.watcher {
    width: 36.857%;
    overflow: hidden;
  }
  
  .add-wrap .card.related {
    width: 61.071%;
    overflow: hidden;
  }
  
  .add-wrap .col {
    padding: 0;
  }
  
  .add-wrap .card-title-area {
    display: flex;
    align-items: center;
    gap: 0 0.533rem;
  }
  
  .add-wrap .card-title-area .icon {
    display: block;
    width: 24px;
    height: 24px;
  }
  
  .add-wrap .card-title-area .title-text {
    font-family: 'NanumGothic';
    font-size: 18px;
    font-weight: 700;
    line-height: 150%;
  }
  
  .add-wrap .card-title-area .total-num {
    min-width: 36px;
    padding: 2px 8px;
    border-radius: 40px;
    background-color: #2E2E38;
    color: #FFE305;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 700;
    line-height: 150%;
    text-align: center;
  }
  
  .add-wrap .input-group .btn {
    width: 100%;
    min-height: 40px;
    padding: 0.533rem 0.8rem 0.533rem 1.066rem;
    border-radius: 10px;
    border: 1px solid #E7E7EE;
    background: #FFF;
    color: #AAA;
    font-family: 'NanumGothic';
    font-size: 16px;
    font-weight: 400;
    line-height: 150%;
  }
  
  .add-wrap .input-group .btn.btn-outline-secondary:focus {
    box-shadow: none;
  }
  
  .add-wrap .input-group .btn .btn-inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .add-wrap .tag-list {
    display: flex;
    flex-wrap: wrap;
    gap: 0.666rem;
    margin-top: 1.333rem;
  }
  
  .add-wrap .b-form-tags .badge {
    /* gap: 0 0.55rem; */
    height: 2.666rem;
    padding: 0.533rem 1rem 0.533rem 0.533rem;
    color: #2E2E38;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 400;
    line-height: 150%;
    border-radius: 40px;
    background: #EDF1FF;
  }
  
  .add-wrap .b-form-tags .badge:hover {
    background-color: #DAE2FF;
  }
  
  .add-wrap .b-form-tags .badge .profile-img {
    display: inline-block;
    width: 24px;
    height: 24px;
    margin-right: 0.8rem;
    border-radius: 50%;
    overflow: hidden;
  }
  
  .card.related .custom-scrollbar {
    padding: 0 2.0833vw;
    margin-bottom: 0.4rem;
    max-height: 15.333rem;
    min-height: 15.333rem;
    overflow-y: auto;
  }
  
  .card.related .memo-area {
    padding-top: 0.666rem;
  }
  
  .card.related .memo-box {
    padding-bottom: 1.333rem;
  }
  
  .card.related .memo-box:last-child {
    padding-top: 1.333rem;
    border-top: 1px solid #DDDDE3;
  }
  
  .card.related .memo-title-area {
    padding-left: 6px;
    margin-bottom: 8px;
    color: #2E2E38;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 700;
    line-height: 150%;
  }
  
  .card.related .subordinate-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0 0.666rem;
    width: fit-content;
    max-width: 100%;
    padding: 0.533rem 1rem;
    border-radius: 40px;
    background-color: #2E2E38;
    cursor: pointer;
  }
  
  .card.related .subordinate-item .icon {
    flex-shrink: 0;
    display: block;
    width: 20px;
    height: 20px;
    margin-right: 0.666rem;
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M10.6667 10.1667L7.33333 13.5L4 10.1667" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.0002 6.16667L7.3335 6.16667L7.3335 13.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
    background-repeat: no-repeat;
  }
  
  .card.related .subordinate-item .custom-listTextstyle {
    color: #FFF;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 400;
    line-height: 150%;
  }
  
  .card.related .subordinate-item .subordinate-id {
    flex-shrink: 0;
    position: relative;
    padding-right: 0.666rem;
    margin-right: 0.666rem;
    color: #FFF;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 700;
    line-height: 150%;
  }
  
  .card.related .subordinate-item .subordinate-id::after {
    content: '';
    display: block;
    position: absolute;
    right: 0;
    top: 3px;
    width: 1px;
    height: 14px;
    background-color: #747480;
  }
  
  .card.related .subordinate-item .badge-container {
    width: auto;
    gap: unset;
    flex-shrink: 0;
  }
  
  .card.related .subordinate-item .badge-container .btn.status-tag {
    width: auto;
    padding: 0.266rem 0.666rem;
    margin-right: 0.933rem;
    border-radius: 60px;
    background: rgba(255, 255, 255, 0.30);
    text-align: center;
    color: #FFF;
    font-family: 'NanumGothic';
    font-size: 12px;
    font-weight: 700;
    line-height: 150%;
    opacity: 1;
  }
  
  .card.related .subordinate-item .badge-container .btn-delete {
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M12 12L4 4" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 4L4 12" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  }
  
  .card.related .superior-list {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.4rem 0.8rem;
  }
  
  .card.related .superior-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0 0.666rem;
    max-width: 28.466rem;
    padding: 0.533rem 1rem;
    border-radius: 40px;
    border: 1px solid #DDDDE3;
    background-color: #FFF;
    cursor: pointer;
  }
  
  .card.related .superior-item .icon {
    flex-shrink: 0;
    display: block;
    width: 20px;
    height: 20px;
    margin-right: 0.666rem;
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M10.6667 9.33333L7.33333 6L4 9.33333" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.0002 13.3333L7.3335 13.3333L7.3335 6" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
    background-repeat: no-repeat;
  }
  
  .card.related .superior-item .superior-id {
    flex-shrink: 0;
    position: relative;
    padding-right: 0.666rem;
    margin-right: 0.666rem;
    color: #2E2E38;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 700;
    line-height: 150%;
  }
  
  .card.related .superior-item .superior-id::after {
    content: '';
    display: block;
    position: absolute;
    right: 0;
    top: 5px;
    width: 1px;
    height: 12px;
    background-color: #C4C4CD;
  }
  
  .card.related .superior-item .badge-container .btn.status-tag {
    padding: 0.266rem 0.666rem;
    background-color: #E7E7EE;
    color: #2E2E38;
    text-align: center;
    font-family: 'NanumGothic';
    font-size: 12px;
    font-weight: 700;
    line-height: 150%;
    border-radius: 60px;
    opacity: 1;
  }
  
  .related-chatter-tag {
    gap: 0 0.666rem;
    align-items: center;
    max-width: 100%;
    padding: 0.533rem 1rem;
    border-radius: 40px;
    background: #FFF1ED;
  }
  
  .related-chatter-tag:hover {
    background-color: #FFD8CC;
  }
  
  .custom-listTextstyle {
    color: #2E2E38;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 400;
    line-height: 150%;
  }
  
  .related-id {
    position: relative;
    padding-right: 0.666rem;
    margin-right: 0.666rem;
    font-weight: 700;
  }
  
  .related-id::after {
    content: '';
    display: block;
    position: absolute;
    right: 0;
    top: 2px;
    width: 1px;
    height: 14px;
    background-color: #747480;
  }
  
  .badge-container {
    justify-content: space-between;
    gap: 0 0.933rem;
    width: auto;
  }
  
  .badge-container:hover {
    border-color: #2E2E38;
  }
  
  .badge-container .btn {
    width: auto;
    padding: 0.266rem 0.666rem;
    overflow: initial;
    text-overflow: unset;
    border-radius: 60px;
    color: #FFF;
    font-family: 'NanumGothic';
    font-size: 12px;
    font-weight: 700;
    line-height: 150%;
  }
  
  .badge-container .badge.in-progress {
    background-color: #FF5C00;
  }
  
  .badge-container .badge.to-do {
    background-color: #747480;
  }
  
  .badge-container .badge.cancelled {
    background-color: #E4E4EA;
    color: #747480;
  }
  
  .badge-container .badge.closed {
    background-color: #168D4C;
  }
  
  .badge-container .badge.done {
    background-color: #1755CC;
  }
  
  /* 파일 업로드 / 파일 리스트 영역 */
  .file-upload-btn-wrap {
    padding-left: 0.7812vw;
  }
  
  .file-list {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 2rem;
    margin-top: 1.333rem;
  }
  
  .file-item {
    position: relative;
    flex-direction: column;
    min-height: 280px;
    padding: 1.333rem;
    border-radius: 20px;
    border: 1px solid #C4C4CD;
    background-color: #fff;
  }
  
  .file-item:hover {
    border-color: #2E2E38;
  }
  
  .file-info-area {
    padding-right: 24px;
  }
  
  .file-info-area .file-name {
    display: -webkit-box;
    width: 100%;
    height: 42px;
    color: #2E2E38;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 700;
    line-height: 150%;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    word-break: break-all;
  }
  
  .file-info-area .file-upload-time {
    display: block;
    margin-top: 0.133rem;
    color: #747480;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 400;
    line-height: 150%;
  }
  
  .file-info-area .desc-tag-list {
    display: flex;
    gap: 0.666rem;
    flex-wrap: wrap;
    margin-top: 0.8rem;
    margin-bottom: 1.4rem;
    padding: 0;
  }
  
  .file-info-area .desc-tag-list .desc-tag-item {
    width: fit-content;
    max-width: 100%;
    padding: 0.3rem 0.8rem;
    list-style: none;
    border-radius: 60px;
    background-color: #F6F6FA;
    color: #747480;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 400;
    line-height: 150%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .file-desc-area {
    margin: 0.8rem 0 0.666rem;
    font-size: 0.7rem;
  }
  
  .file-item .btn-delete {
    position: absolute;
    top: 1.333rem;
    right: 1.333rem;
    display: block;
    width: 20px;
    height: 20px;
    font-size: 0;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15 15L5 5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M15 5L5 15" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat transparent;
  }
  
  .card.file .file-item .image-item {
    position: relative;
    width: 70px;
    height: 70px;
    padding-bottom: 100%;
    border-radius: 6px;
    overflow: hidden;
  }
  
  .card.file .file-item .image-item>div {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
  
  .card.file .file-item .image-item>div:hover:after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
  }
  
  .card.file .file-item .image-item .image-box {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border: unset;
  }
  
  /* comment 영역 */
  .card.comment .card-body {
    align-items: stretch;
    padding: 0;
  }
  
  .card.comment .comment-title-area {
    display: flex;
    align-items: center;
    gap: 0 0.8rem;
  }
  
  .card.comment .comment-title-area h3 {
    margin-bottom: 0;
    color: #2E2E38;
    font-family: 'NanumGothic';
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%;
  }
  
  .card.comment .comment-title-area .total-num {
    min-width: 36px;
    height: 25px;
    padding: 0 0.6rem;
    border-radius: 40px;
    background-color: #2E2E38;
    color: #FFE305;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 700;
    line-height: 25px;
    text-align: center;
  }
  
  .card.comment .comment-area .comment-title-area .total-num {
    background-color: #2E2E38;
  }
  
  .card.comment .highlight-area .comment-title-area .total-num {
    background-color: #2356F6;
    color: #FFF;
  }
  
  .card.comment .comment-area {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  
  .card.comment .comment-list-wrap {
    flex-grow: 1;
    flex-shrink: 0;
    padding-top: max(2rem, 1.5625vw);
    padding-bottom: max(2rem, 1.5625vw);
    padding-left: 2.666rem;
    padding-right: 2.0833vw;
  }
  
  .card.comment .comment-list {
    display: flex;
    flex-direction: column;
    gap: 2.666rem 0;
  }
  
  .card.comment .highlight-area {
    width: 35%;
    min-width: 26.133rem;
  }
  
  .card.comment .highlight-area .comment-title-area {
    height: 6.4rem;
    padding-top: max(2rem, 1.5625vw);
    padding-left: 2.0833vw;
    padding-right: 2.666rem;
    padding-bottom: max(2rem, 1.5625vw);
  }
  .tab-title{
    font-family: "NanumGothic";
    font-size: 1.3rem;
    font-weight: bold;
    padding:0 0.2rem;
  }
  
  .card.comment .highlight-area .comment-list {
    height: calc(100% - 6.8rem);
    padding-left: 2.0833vw;
    padding-right: calc(2.666rem - 0.933rem);
    overflow-y: auto;
  }
  
  
  /* 하단 버튼 영역 */
  .chatter-btn-wrap {
    position: sticky;
    bottom: 0;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 1.333rem 3.125vw;
    gap: 0.666rem;
    align-items: center;
    margin-left: -3.125vw;
    margin-right: -3.125vw;
    z-index: 999;
    background-color: #f6f6fa;
    box-shadow: 0px -10px 30px 0px rgba(46, 46, 56, 0.14);
  }
  
  .chatter-btn-wrap.bottom {
    box-shadow: none;
  }
  
  .chatter-btn-wrap .btn-move-wrap {
    display: flex;
    gap: 0 0.8rem;
  }
  
  .chatter-btn-wrap .text-container .text {
    color: #747480;
    font-family: 'NanumGothic';
    font-size: 12px;
    font-weight: 400;
    line-height: 150%;
  }
  
  .chatter-btn-wrap .button-container {
    display: flex;
    gap: 0 10px;
    margin: 0;
    padding: 0;
  }
  
  label.no-text {
    font-size: 14px;
    color: transparent;
  }
  
  .br-pc {
    display: none;
  }
  
  .config-error {
    border: 1px solid #ff0000 !important;
  }
  
  .config-error-message {
    color: red;
    position: absolute;
    bottom: -22px;
    font-size: 11px;
    font-family: 'NanumGothic';
  }
  .config-option-error-message {
    color: red;
    position: absolute;
    /* bottom: -22px; */
    font-size: 11px;
    font-family: 'NanumGothic';
  }
  
  
  .config-option {
    display: flex;
    align-items: center;
    width: 16vw;
    margin: 0 1.8rem 1.5rem 0.5rem;
  }
  .config-option-level{
    display: flex;
    align-items: center;
    min-width: 15%;
    margin: 0 3rem 0 0;
  }
  .config-option-level >label{
    min-width: 30px !important;
  }
  
  
  @media all and (min-width: 1280px) {
  
    .card:first-child .form-row>.col,
    .card:first-child .form-row>[class*="col-"] {
      display: flex;
      align-items: center;
    }
  
    .lv1 {
      flex: 0 0 25%;
      max-width: 25%;
    }
  
    .form-group {
      flex-grow: 1;
      flex-shrink: 0;
      max-width: 100%;
    }
  
  
    label {
      min-width: 90px;
      margin-bottom: 0;
      padding-left: 0;
      padding-right: 8px;
    }
  
    label.no-text {
      min-width: unset;
      font-size: 0;
    }
  
    .date-wrap {
      flex-grow: 1;
      flex-shrink: 0;
    }
  
    .date-wrap .mb-0 {
      padding-left: 0;
    }
  
    .date-wrap .mb-0:first-child {
      padding-right: 0;
    }
  
    .date-area {
      display: flex;
      align-items: center;
    }
  
    .date-area label {
      padding-left: 10px;
      margin-right: 12px;
    }
  
    .br-pc {
      display: block;
    }
    .chatter-file-size {
      font-size: 0.9rem;
    }
    .chatter-file-size.total,
    .chatter-file-size.ready-to-upload {
      font-weight: bold;
      font-size: 1rem;
      margin-top: 1rem;
    }
    .chatter-file-size.ready-to-upload span {
      color: red;
      font-size: 0.8rem;
      font-weight: right;
    }
  
    .comment .tab-pane {
      display:flex;
      /* border-radius: 0.6rem !important; */
    }
    .nav-tabs .nav-link {
      border:none;
    }
  
    /* Optional: To give a border radius to the active tab */
    .nav-tabs .nav-link.active {
      border:none;
      border-radius: 10px 10px 0 0; /* Adjust the values as needed */
    }
    .comment .timeline-area {
      width:100%;
      padding-top: max(2rem, 1.5625vw);
      padding-bottom: max(2rem, 1.5625vw);
      padding-left: 2.666rem;
      padding-right: 2.0833vw;
    }
  
    .revision-area {
      padding: 0.866rem 0.866rem 1.666rem;
      width: 100%;
      border-radius: 0.6rem;
      height: 35rem;
      overflow-x: scroll;
    }
  }
  
  @media all and (max-width: 1300px) {
    .file-list {
      grid-template-columns: repeat(3, 1fr);
    }
  }</style>
